export default {"src":"/_next/static/media/Female-09.824af683.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};